import React from "react";
import {
  Box,
  Stack,
  Grid,
} from "@mui/material";
import { useGlobalDataContext } from "../../Context/AppGlobalData";
import { formattedDate } from "../../util";
const MaterialRlsPdf = React.forwardRef((props, ref) => {
  console.log("props", props);
  const [filter] = React.useState(props.filter)
  const { shipmentInstruction } =
    useGlobalDataContext();
    const [wgtUm] = React.useState(props.wgtUm)
  return (
    <div ref={ref}>

      <Stack spacing={2} >
        <Box
          sx={{
            display: 'none',
            displayPrint: 'block',

            fontSize: '16pt',
            fontWeight: '700',
            textAlign: "center"
          }}
        >
          Material Release by {props.by==="T"?"Tag":"Weight"}  
        </Box>
        <Grid container sx={{ padding: "5px", border: "2px solid" }} spacing={1} direction="row" >
          {Object.keys(filter).map((k) =>

            <Grid item xs={12}  >{k + " : " + filter[k]}</Grid>
          )
          }

        </Grid>
        <Grid container sx={{ padding: "5px", border: "2px solid" }} direction="row" >

        
          <Grid item xs={12} >Shipping Instruction :{shipmentInstruction}</Grid>

      






        </Grid>
      </Stack>
    
      <div className="spacing"></div>
      <table>
        
        <tr>
          <th>Part Number</th>
          <th>Mill Order No.</th>
          {props.by !== "T"?null: <> <th>End-User PO</th>
          <th>Mill Coil ID</th> </>}
          <th>Proc. Order No.</th>
          {props.by !== "T"?null: <th>Proc. Coil ID</th>}
          <th>Gauge</th>
          <th className="leftAlign">Width</th>
          <th className="leftAlign">Length</th>
          <th className="leftAlign">{wgtUm}</th>
          <th className="leftAlign">Pieces</th>
          {props.by ==="T"?null: <th className="leftAlign">Shipment {wgtUm}</th>} 
          <th>Date/Time</th>
        </tr>
       
        {props.data.map((row, key) =>
             <tr className={  row.isTot === 1 ? "bold":''}>
              <td >{row.partNo}</td>
              <td>{row.cusPoNo}</td>
              {props.by !=="T"?null:<><td>{row.eusrPoNo}</td>
              <td>{row.cusTagNo}</td></> }
              <td>{row.procrOrdStr}</td>
              {props.by !=="T"?null:  <td>{row.procrTagNo}</td>}
           
             
              <td>{row.gaStr}</td>
              <td className="leftAlign">{row.wdthStr}</td>
              <td className="leftAlign">{row.lgthStr}</td>
              <td className="leftAlign">{row.wgtStr}</td>
              <td  className="leftAlign">{row.pcsStr}</td>
           
            
              {props.by==="T"?null: <td className="leftAlign">{row.release_weight}</td>} 
              <td>{formattedDate(row.release_date,"MM-DD-YYYY HH:mm ")}</td>
            </tr>
          



        )}

      </table>



    </div>
  );
});

export default MaterialRlsPdf;
